import React, { useEffect, useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import Input from "../Input";
import InputSelect from "../InputSelect";
import api from "../../services/api";
import { toast } from "react-toastify";
import { renderError } from "../../helpers/errors";
import { hasPermission } from "../../services/auth";
import origins from "../../seeds/origins";
import SelectCustomerCompany from "../selects/SelectCustomerCompany";

// Calculado na abertura, não no import: o módulo carrega antes do login, e aí
// as permissões ainda não existem.
const getTypes = () => [
    {label: 'Cliente', value: 'customer'},
    {label: 'Transportadora', value: 'shipping'},
    ...(hasPermission('company_supplier') ? [
        {label: 'Fornecedor de gravação', value: 'customization'},
        {label: 'Fornecedor de produto', value: 'product'},
    ] : []),
    ...(hasPermission('company_billing') ? [{label: 'Faturamento', value: 'billing'}] : []),
];


export const ModalCreateCustomer = ({show, close, type, defaultType, companies, defaultCompanies, brands, hideCompany, showSuccess, customerStored, level}) => {
    const [loading, setLoading] = useState(false);

    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerCpf, setCustomerCpf] = useState('');
    const [customerCompanies, setCustomerCampanies] = useState([]);
    const [customerType, setCustomerType] = useState([]);

    const types = show ? getTypes() : [];

    const initialType = () => {
        if (!defaultType) return [];

        const allowed = getTypes().map(option => option.value);
        const wanted = defaultType.filter(value => allowed.includes(value));
        return wanted.length > 0 ? wanted : ['customer'];
    };

    useEffect(() => {
        if(!show) {
            clean();
            return;
        }

        setCustomerType(initialType());
        if (defaultCompanies && defaultCompanies.length > 0) {
            // Empresa(s) pré-selecionada(s) ao abrir (ex.: empresa vinculada da marca)
            setCustomerCampanies(defaultCompanies);
        }
    }, [show]);

    const storeCustomer = () => {
        setLoading(true);

        api.post(`/customer`, {
            name: customerName,
            email: customerEmail,
            phone: customerPhone,
            cpf: customerCpf || null,
            company_ids: companies ?? customerCompanies,
            type: type ?? customerType,
            // admin_id: customerAdmin,
            ...(brands && brands.length > 0 && { brands })
        }).then(res => {
            {showSuccess !== false &&
                toast.success('Pessoa cadastrada com sucesso');
            }
            if (typeof customerStored === 'function') {
                customerStored(res.data.resource);
            }
            setLoading(false);
            clean();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const clean = () => {
        setCustomerName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setCustomerCpf('');
        setCustomerCampanies([]);
        setCustomerType([]);
    }

    return (
        <Modal
            title={`Cadastrar pessoa`}
            show={show}
            close={close}
            level={level}
            footer={
                <Button 
                    type={`primary`}
                    size={`small`}
                    text={`Cadastrar`}
                    svg={`save-white`}
                    action={storeCustomer}
                    loading={loading}
                />
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <Input type={`text`} label={`Nome`} change={setCustomerName} value={customerName}/>
                    </div>
                </div>   
                <div className="row">
                    <div className="col">
                        <Input type={`text`} label={`E-mail`} change={setCustomerEmail} value={customerEmail} />
                    </div>
                </div>   
                <div className="row">
                    <div className="col">
                        <Input type={`text`} label={`Telefone`} change={setCustomerPhone} value={customerPhone} mask={`convertToPhone`} />
                    </div>
                </div>   
                <div className="row">
                    <div className="col">
                        <Input type={`text`} label={`CPF`} change={setCustomerCpf} value={customerCpf} mask={`convertToCpf`} />
                    </div>
                </div>
                {!companies && hideCompany !== true &&
                    <div className="row">
                        <div className="col">
                            <SelectCustomerCompany
                                isMulti={true}
                                selectedCustomerCompany={customerCompanies}
                                setSelectedCustomerCompany={setCustomerCampanies}
                                />
                        </div>
                    </div>   
                }
                {!type &&
                    <div className="row">
                        <div className="col">
                            <InputSelect label={`Marcadores`} options={types} value={customerType} change={setCustomerType} isMulti={true} />
                        </div>
                    </div>
                }
            </div>
        </Modal>
    );
}

export default ModalCreateCustomer;